<template>
  <div>
    <div
      class="d-flex justify-content-center align-items-center h-75"
      v-if="carregando"
    >
      <v-progress-circular indeterminate size="32" color="#462181" width="2"
        ><v-progress-circular
          indeterminate
          size="24"
          color="#ff7f00"
          width="2"
          rotate="180"
        ></v-progress-circular
      ></v-progress-circular>
    </div>

    <div v-else>
      <modal name="modal-detalhes-licenciada" width="550px" height="auto">
        <modal-detalhes-licenciada
          @botao-voltar="$modal.hide('modal-detalhes-licenciada')"
          @botao-editar="editarSistema($event)"
          @exibir-toast="exibirToast($event)"
          :item="itemSelecionado"
        />
      </modal>
      <modal name="configuracoes-extra" width="700px" height="540px">
        <configuracoes-extras
          @botao-voltar="$modal.hide('configuracoes-extra')"
          :licenciada="itemSelecionado"
        />
      </modal>

      <!-- Sistema preso a conector removido some da lista (não funciona sem
      o lic_token). Avisa em vez de sumir em silêncio — o caso acontece
      quando alguém apaga o conector antes de religar os sistemas. -->
      <div v-if="sistemasOrfaos > 0" class="pnc-aviso">
        <i class="fas fa-triangle-exclamation"></i>
        <div>
          <strong>
            {{ sistemasOrfaos }}
            {{ sistemasOrfaos === 1 ? "sistema está" : "sistemas estão" }}
            vinculado{{ sistemasOrfaos === 1 ? "" : "s" }} a um conector
            removido
          </strong>
          <span
            >Eles não aparecem na lista abaixo e não conseguem se conectar. Para
            reativá-los, é preciso vinculá-los a um conector ativo.</span
          >
        </div>
      </div>

      <!-- Visão panorâmica: contagens rápidas de sistemas/conectores. -->
      <div class="pnc-resumo">
        <div class="pnc-resumo__item">
          <span class="pnc-resumo__icone pnc-resumo__icone--roxo"
            ><i class="fas fa-database"></i
          ></span>
          <div class="pnc-resumo__dados">
            <span class="pnc-resumo__valor">{{ sistemas.length }}</span>
            <span class="pnc-resumo__rotulo">Sistemas</span>
            <span class="pnc-resumo__sub">{{ textoSistemasAtivos }}</span>
          </div>
        </div>
        <div class="pnc-resumo__item">
          <span class="pnc-resumo__icone pnc-resumo__icone--verde"
            ><i class="fas fa-circle-nodes"></i
          ></span>
          <div class="pnc-resumo__dados">
            <span class="pnc-resumo__valor">{{ licenciadas.length }}</span>
            <span class="pnc-resumo__rotulo">Conectores</span>
            <span class="pnc-resumo__sub"
              >{{ qtdConectoresOnline }} online</span
            >
          </div>
        </div>
        <div class="pnc-resumo__item">
          <span class="pnc-resumo__icone pnc-resumo__icone--azul"
            ><i class="fas fa-signal"></i
          ></span>
          <div class="pnc-resumo__dados">
            <span class="pnc-resumo__valor">{{ percentualConectividade }}</span>
            <span class="pnc-resumo__rotulo">Conectividade</span>
            <span
              class="pnc-resumo__sub"
              :class="{ 'pnc-resumo__sub--alerta': qtdConectoresOffline > 0 }"
              >{{ textoConectividade }}</span
            >
          </div>
        </div>
        <div class="pnc-resumo__item">
          <span class="pnc-resumo__icone pnc-resumo__icone--ambar"
            ><i class="fas fa-clock"></i
          ></span>
          <div class="pnc-resumo__dados">
            <span class="pnc-resumo__valor pnc-resumo__valor--texto">{{
              ultimaComunicacao || "—"
            }}</span>
            <span class="pnc-resumo__rotulo">Última conexão</span>
            <span class="pnc-resumo__sub">Mais recente</span>
          </div>
        </div>
      </div>

      <div class="pnc-secao">
        <h6 class="pnc-titulo">
          Sistemas conectados
          <span class="pnc-titulo__contador">{{
            sistemasFiltrados.length
          }}</span>
        </h6>

        <!-- Filtros no mesmo desenho dos chips da Timeline. -->
        <div class="pnc-filtros">
          <div class="pnc-busca">
            <i class="fas fa-magnifying-glass"></i>
            <input
              v-model="buscaSistema"
              type="text"
              placeholder="Buscar sistema"
            />
            <button
              v-if="buscaSistema"
              type="button"
              title="Limpar busca"
              @click="buscaSistema = ''"
            >
              <i class="fas fa-xmark"></i>
            </button>
          </div>

          <button
            v-for="tipo in tiposDisponiveis"
            :key="tipo.chave"
            type="button"
            class="pnc-chip"
            :style="
              filtroTipo === tipo.chave
                ? {
                    background: tipo.fundo,
                    borderColor: tipo.cor,
                    color: tipo.cor
                  }
                : {}
            "
            @click="alternarTipo(tipo.chave)"
          >
            <i :class="['fas', tipo.icone]" :style="{ color: tipo.cor }"></i>
            {{ tipo.label }}
            <span class="pnc-chip__contador">{{ tipo.quantidade }}</span>
          </button>

          <button
            v-if="filtroTipo || buscaSistema"
            type="button"
            class="pnc-chip pnc-chip--limpar"
            title="Limpar filtros"
            @click="limparFiltrosSistemas"
          >
            <i class="fas fa-xmark"></i>
          </button>
        </div>
      </div>

      <b-table
        id="tabelaSistemasConectados"
        small
        :current-page="paginacaoSistemas.paginaAtual"
        :per-page="paginacaoSistemas.porPagina"
        :fields="fieldsSistemas"
        :items="sistemasFiltrados"
        :sort-by.sync="ordemSistemas"
        :sort-desc.sync="ordemSistemasDesc"
        responsive="sm"
        show-empty
        empty-text="Nenhum sistema encontrado com esses filtros."
        hover
      >
        <template #cell(sli_titulo)="row">
          <div
            class="pnc-sistema"
            title="Ver detalhes"
            @click="detalhes(row.item)"
          >
            <span
              class="pnc-sistema__icone"
              :style="{
                color: row.item.tipoConexao.cor,
                background: row.item.tipoConexao.fundo
              }"
            >
              <i :class="['fas', row.item.tipoConexao.icone]"></i>
            </span>
            <span class="pnc-sistema__texto">
              <span class="pnc-sistema__nome">{{ row.item.sli_titulo }}</span>
              <!-- Sistema, tipo e banco viram badges: em texto corrido
              ficavam quase invisíveis embaixo do nome. -->
              <span class="pnc-sistema__badges">
                <span
                  v-for="(badge, i) in row.item.badges"
                  :key="i"
                  class="pnc-badge"
                  :style="{ color: badge.cor, background: badge.fundo }"
                  >{{ badge.texto }}</span
                >
              </span>
            </span>
          </div>
        </template>

        <template #cell(sli_db_dsn)="data">
          <div class="pnc-endereco">{{ data.value || "—" }}</div>
        </template>

        <template #cell(conectorDescricao)="row">
          <div v-if="row.item.conectorDescricao" class="pnc-conector-col">
            <span class="pnc-conector-col__nome">{{
              row.item.conectorDescricao
            }}</span>
            <span class="pnc-status" :class="row.item.statusConector.classe">
              <i :class="['fas', row.item.statusConector.icone]"></i>
              {{ row.item.statusConector.texto }}
            </span>
          </div>
          <span v-else class="pnc-status pnc-status--alerta">
            <i class="fas fa-triangle-exclamation"></i> Sem conector
          </span>
        </template>

        <template #cell(sli_data_ativacao)="data">
          <span v-if="data.value" class="pnc-ultimo-teste">{{
            obterDataFormatada(data.value)
          }}</span>
          <span v-else class="pnc-ultimo-teste pnc-ultimo-teste--nunca"
            >Nunca testado</span
          >
        </template>

        <template #cell(testarConexao)="row">
          <b-button
            size="sm"
            variant="outline-primary"
            :disabled="!row.item.podeTestarConexao"
            v-b-tooltip.hover
            :title="row.item.motivoSemTeste"
            @click="testarConexao(row.item)"
          >
            <i class="fas fa-satellite-dish mr-1"></i> Testar
          </b-button>
        </template>

        <template #cell(acoes)="row">
          <!-- Mesmo desenho do menu dos cards de conector: os dois estão na
          mesma tela, não faz sentido terem aparências diferentes. -->
          <b-dropdown
            no-caret
            variant="link"
            dropleft
            size="sm"
            toggle-class="pnc-conector__menu p-0"
            menu-class="trocar-conta-menu"
          >
            <template #button-content>
              <i class="fas fa-ellipsis-vertical"></i>
            </template>
            <b-dropdown-item @click="detalhes(row.item)"
              ><i class="fas fa-circle-info mr-2"></i>Detalhes</b-dropdown-item
            >
            <b-dropdown-item
              v-if="row.item.sistema_obj.sis_visibilidade"
              @click="editarSistema(row.item)"
              ><i class="fas fa-pen mr-2"></i>Editar</b-dropdown-item
            >
            <b-dropdown-item @click="exibirConfiguracoesExtras(row.item)"
              ><i class="fas fa-sliders mr-2"></i>Propriedades</b-dropdown-item
            >
            <b-dropdown-item @click="apagarSistema(row.item)"
              ><i class="fas fa-trash mr-2"></i>Remover</b-dropdown-item
            >
          </b-dropdown>
        </template>
      </b-table>
      <div
        class="d-flex justify-content-center"
        v-if="sistemasFiltrados.length > paginacaoSistemas.porPagina"
      >
        <b-pagination
          v-model="paginacaoSistemas.paginaAtual"
          :total-rows="sistemasFiltrados.length"
          :per-page="paginacaoSistemas.porPagina"
          aria-controls="tabelaSistemasConectados"
          align="fill"
        ></b-pagination>
      </div>
      <div v-else-if="!sistemas.length" class="pnc-vazio">
        Nenhum sistema conectado ainda.
      </div>

      <div class="pnc-secao mt-6">
        <h6 class="pnc-titulo">
          Conectores
          <span class="pnc-titulo__contador">{{ licenciadas.length }}</span>
        </h6>

        <div class="pnc-secao__acoes">
          <!-- Padrão é status + mais novo primeiro, mas nem sempre é o que
          a pessoa procura — daí poder trocar. -->
          <div class="pnc-ordem">
            <button
              v-for="opcao in ORDENS_CONECTOR"
              :key="opcao.chave"
              type="button"
              class="pnc-ordem__btn"
              :class="{
                'pnc-ordem__btn--ativo': ordemConectores === opcao.chave
              }"
              v-b-tooltip.hover
              :title="opcao.titulo"
              @click="ordemConectores = opcao.chave"
            >
              <i :class="['fas', opcao.icone]"></i>
            </button>
          </div>

          <!-- 3 por vez; o resto entra deslizando. -->
          <div v-if="totalPaginasConectores > 1" class="pnc-slide-nav">
            <button
              type="button"
              class="pnc-slide-btn"
              :disabled="paginaConectores === 0"
              title="Anteriores"
              @click="paginaConectores--"
            >
              <i class="fas fa-chevron-left"></i>
            </button>
            <span class="pnc-slide-pos"
              >{{ paginaConectores + 1 }}/{{ totalPaginasConectores }}</span
            >
            <button
              type="button"
              class="pnc-slide-btn"
              :disabled="paginaConectores >= totalPaginasConectores - 1"
              title="Próximos"
              @click="paginaConectores++"
            >
              <i class="fas fa-chevron-right"></i>
            </button>
          </div>

          <!-- Reiniciar o conector ou mandar atualizar a licenca muda o
          status quase na hora, mas so refletia aqui reabrindo o modal.
          Cooldown de 10s pra nao virar um jeito de martelar o backend. -->
          <button
            type="button"
            class="card-acao"
            :disabled="cooldownAtivo"
            v-b-tooltip.hover
            :title="
              cooldownAtivo
                ? 'Consultando os conectores — o status leva alguns segundos para ser reportado'
                : 'Atualizar status dos conectores e sistemas'
            "
            @click="atualizarManual"
          >
            <i :class="['fas', 'fa-rotate', { 'fa-spin': atualizando }]"></i>
            {{
              atualizando ? `Atualizando (${segundosRestantes}s)` : "Atualizar"
            }}
          </button>
        </div>
      </div>

      <div class="pnc-conectores">
        <div
          v-for="conector in conectoresVisiveis"
          :key="conector.licenciada_id"
          class="pnc-conector"
        >
          <div class="pnc-conector__cabecalho">
            <span
              class="pnc-conector__icone"
              :class="{ 'pnc-conector__icone--off': !conector.online }"
            >
              <i class="fas fa-circle-nodes"></i>
            </span>

            <div class="pnc-conector__identificacao">
              <div class="pnc-conector__titulo">
                <span class="pnc-conector__nome">{{
                  conector.lic_descricao || "Sem descrição"
                }}</span>
                <span
                  class="pnc-status"
                  :class="
                    conector.online
                      ? 'pnc-status--online'
                      : 'pnc-status--offline'
                  "
                >
                  <i
                    :class="[
                      'fas',
                      conector.online ? 'fa-link' : 'fa-link-slash'
                    ]"
                  ></i>
                  {{ conector.online ? "Online" : "Offline" }}
                </span>
              </div>
              <div v-if="conector.lic_versao" class="pnc-conector__versao">
                Versão {{ conector.lic_versao }}
              </div>
              <div class="pnc-conector__linha">
                <i class="fas fa-clock mr-1"></i>
                {{
                  conector.online
                    ? "Online desde " + conector.onlineDesde
                    : "Última comunicação: " + conector.onlineDesde
                }}
              </div>
            </div>

            <b-dropdown
              no-caret
              variant="link"
              dropleft
              size="sm"
              toggle-class="pnc-conector__menu p-0"
              menu-class="trocar-conta-menu"
            >
              <template #button-content>
                <i class="fas fa-ellipsis-vertical"></i>
              </template>
              <b-dropdown-item @click="editarConector(conector)"
                ><i class="fas fa-pen mr-2"></i>Editar</b-dropdown-item
              >
              <b-dropdown-item @click="atualizarCredenciaisConector(conector)"
                ><i class="fas fa-rotate mr-2"></i>Atualizar
                credenciais</b-dropdown-item
              >
              <b-dropdown-item @click="apagarConector(conector)"
                ><i class="fas fa-trash mr-2"></i>Remover</b-dropdown-item
              >
            </b-dropdown>
          </div>

          <div class="pnc-conector__rodape">
            <i class="fas fa-database mr-1"></i>
            {{ conector.qtdSistemas }}
            {{
              conector.qtdSistemas === 1
                ? "sistema conectado"
                : "sistemas conectados"
            }}
          </div>
        </div>
        <div v-if="!licenciadas.length" class="pnc-vazio">
          Nenhum conector cadastrado ainda.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModalDetalhesLicenciada from "../licenciada/components/ModalDetalhesLicenciada.vue";
import ConfiguracoesExtras from "../licenciada/components/ConfiguracoesExtras.vue";
import ApiService from "@/core/services/api.service";
import Swal from "sweetalert2";
import API_LINKS from "../api.links";
import moment from "moment";

// Tipos sem consulta SQL de teste cadastrada por trás (DataNetProvider::
// testarConexaoSistema exige BancoTipo::bat_sql_teste) -- não é falta de
// implementar o botão, é que esses tipos não têm como ser testados hoje.
const TIPOS_SEM_TESTE_CONEXAO = ["API_E", "API_G", "WHK"];

const TIPO_CONEXAO = {
  API_E: { label: "API", icone: "fa-plug", cor: "#3699ff", fundo: "#e1f0ff" },
  API_G: { label: "API", icone: "fa-plug", cor: "#3699ff", fundo: "#e1f0ff" },
  WHK: {
    label: "Webhook",
    icone: "fa-link",
    cor: "#7c7c8a",
    fundo: "#f3f6f9"
  }
};
const ORDENS_CONECTOR = [
  {
    chave: "status",
    icone: "fa-signal",
    titulo: "Ordenar por status (ativos primeiro) e mais recentes"
  },
  {
    chave: "nome",
    icone: "fa-arrow-down-a-z",
    titulo: "Ordenar por nome"
  },
  {
    chave: "sistemas",
    icone: "fa-database",
    titulo: "Ordenar por quantidade de sistemas"
  }
];

const TIPO_CONEXAO_PADRAO = {
  label: "Banco de Dados",
  icone: "fa-database",
  cor: "#7239ea",
  fundo: "#f2eefa"
};

export default {
  name: "PainelConectores",
  components: {
    ModalDetalhesLicenciada,
    ConfiguracoesExtras
  },
  props: {
    contaId: { type: Number, default: null }
  },
  data() {
    return {
      carregando: true,
      atualizando: false,
      cooldownAtivo: false,
      segundosRestantes: 0,
      intervaloCooldown: null,
      sistemasOrfaos: 0,
      sistemas: [],
      licenciadas: [],
      listaLicencasOnline: [],
      bancos: [],
      sistemasCatalogo: [],
      itemSelecionado: {},
      paginacaoSistemas: {
        paginaAtual: 1,
        porPagina: 5
      },
      paginaConectores: 0,
      CONECTORES_POR_PAGINA: 3,
      ORDENS_CONECTOR,
      ordemConectores: "status",
      // "Tipo de conexão" saiu da tabela: virou filtro e já aparece como
      // badge embaixo do nome, então a coluna só ocupava espaço.
      fieldsSistemas: [
        { key: "sli_titulo", label: "Sistema", sortable: true },
        { key: "sli_db_dsn", label: "Endereço", sortable: true },
        { key: "conectorDescricao", label: "Conector", sortable: true },
        { key: "sli_data_ativacao", label: "Último teste", sortable: true },
        { key: "testarConexao", label: "Testar conexão", class: "text-center" },
        { key: "acoes", label: "Ações", class: "text-center" }
      ],
      ordemSistemas: "sli_titulo",
      ordemSistemasDesc: false,
      filtroTipo: null,
      buscaSistema: ""
    };
  },
  computed: {
    sistemasEnriquecidos() {
      const licenciadaPorId = {};
      this.licenciadas.forEach((l) => {
        licenciadaPorId[l.licenciada_id] = l;
      });

      return this.sistemas.map((sis) => {
        const sistemaObj = this.sistemasCatalogo.find(
          (s) => s.sistema_id == sis.sistema_id
        );
        const bancoObj = this.bancos.find(
          (b) => b.banco_id.trim() == sis.banco_id.trim()
        );
        const conector = licenciadaPorId[sis.licenciada_id];

        return {
          ...sis,
          sistema_obj: sistemaObj,
          banco_obj: bancoObj,
          label_sist_banco: sistemaObj
            ? `${sistemaObj.sis_nome} - ${bancoObj ? bancoObj.bat_nome : ""}`
            : "",
          badges: [
            sistemaObj && {
              texto: sistemaObj.sis_nome,
              cor: "#5e6278",
              fundo: "#f3f6f9"
            },
            {
              texto: (TIPO_CONEXAO[sis.banco_id] || TIPO_CONEXAO_PADRAO).label,
              cor: (TIPO_CONEXAO[sis.banco_id] || TIPO_CONEXAO_PADRAO).cor,
              fundo: (TIPO_CONEXAO[sis.banco_id] || TIPO_CONEXAO_PADRAO).fundo
            },
            bancoObj && {
              texto: bancoObj.bat_nome,
              cor: "#5e6278",
              fundo: "#f3f6f9"
            }
          ].filter(Boolean),
          conectorDescricao: conector ? conector.lic_descricao : null,
          conectorOnline: conector
            ? this.listaLicencasOnline.some(
                (i) => i.lic_token == conector.lic_token
              )
            : false,
          statusConector: this.statusDoConector(sis, conector),
          tipoConexao: TIPO_CONEXAO[sis.banco_id] || TIPO_CONEXAO_PADRAO,
          // Rede de segurança: o backend já esconde sistema de conector
          // removido, mas se algum escapar (base antiga) o teste falharia
          // com 404 — melhor bloquear dizendo o motivo.
          podeTestarConexao:
            !TIPOS_SEM_TESTE_CONEXAO.includes(sis.banco_id) && !!conector,
          motivoSemTeste: !conector
            ? "Sistema sem conector ativo — o conector pode ter sido removido"
            : TIPOS_SEM_TESTE_CONEXAO.includes(sis.banco_id)
            ? "Teste de conexão não disponível para este tipo de sistema"
            : ""
        };
      });
    },
    // Ativo antes de inativo; dentro de cada grupo, do mais novo pro mais
    // antigo — o que acabou de ser cadastrado é o que a pessoa procura.
    conectoresEnriquecidos() {
      return this.licenciadas
        .map((lic) => {
          const online = this.listaLicencasOnline.some(
            (i) => i.lic_token == lic.lic_token
          );
          const qtdSistemas = this.sistemas.filter(
            (s) => s.licenciada_id === lic.licenciada_id
          ).length;

          return {
            ...lic,
            online,
            qtdSistemas,
            onlineDesde: this.formatarUltimaComunicacao(lic.lic_token)
          };
        })
        .sort((a, b) => {
          if (this.ordemConectores === "nome") {
            return (a.lic_descricao || "").localeCompare(b.lic_descricao || "");
          }

          if (this.ordemConectores === "sistemas") {
            return b.qtdSistemas - a.qtdSistemas;
          }

          const ativoA = a.lic_status === "A" ? 0 : 1;
          const ativoB = b.lic_status === "A" ? 0 : 1;
          if (ativoA !== ativoB) return ativoA - ativoB;

          return Number(b.licenciada_id || 0) - Number(a.licenciada_id || 0);
        });
    },
    totalPaginasConectores() {
      return Math.max(
        1,
        Math.ceil(
          this.conectoresEnriquecidos.length / this.CONECTORES_POR_PAGINA
        )
      );
    },
    conectoresVisiveis() {
      const inicio = this.paginaConectores * this.CONECTORES_POR_PAGINA;
      return this.conectoresEnriquecidos.slice(
        inicio,
        inicio + this.CONECTORES_POR_PAGINA
      );
    },
    // Só os tipos que a conta realmente tem — chip de filtro pra tipo
    // inexistente só ocupa espaço e nunca traz resultado.
    tiposDisponiveis() {
      const porChave = {};

      this.sistemasEnriquecidos.forEach((sis) => {
        const cfg = TIPO_CONEXAO[sis.banco_id] || TIPO_CONEXAO_PADRAO;
        if (!porChave[cfg.label]) {
          porChave[cfg.label] = { ...cfg, chave: cfg.label, quantidade: 0 };
        }
        porChave[cfg.label].quantidade += 1;
      });

      return Object.values(porChave).sort((a, b) =>
        a.label.localeCompare(b.label)
      );
    },

    sistemasFiltrados() {
      const termo = this.buscaSistema.trim().toLowerCase();

      return this.sistemasEnriquecidos.filter((sis) => {
        if (this.filtroTipo) {
          const cfg = TIPO_CONEXAO[sis.banco_id] || TIPO_CONEXAO_PADRAO;
          if (cfg.label !== this.filtroTipo) return false;
        }

        if (!termo) return true;

        // Busca no que a linha mostra: nome, badges, endereço e conector.
        return [
          sis.sli_titulo,
          sis.label_sist_banco,
          sis.sli_db_dsn,
          sis.conectorDescricao
        ]
          .filter(Boolean)
          .some((campo) => String(campo).toLowerCase().includes(termo));
      });
    },

    qtdConectoresOnline() {
      return this.conectoresEnriquecidos.filter((c) => c.online).length;
    },
    qtdConectoresOffline() {
      return this.licenciadas.length - this.qtdConectoresOnline;
    },
    percentualConectividade() {
      if (!this.licenciadas.length) return "—";

      return (
        Math.round((this.qtdConectoresOnline / this.licenciadas.length) * 100) +
        "%"
      );
    },
    textoConectividade() {
      if (!this.licenciadas.length) return "Sem conectores";
      if (this.qtdConectoresOffline === 0) return "Sem falhas";

      return this.qtdConectoresOffline === 1
        ? "1 conector offline"
        : `${this.qtdConectoresOffline} conectores offline`;
    },
    textoSistemasAtivos() {
      const ativos = this.sistemas.filter((s) => s.sli_status === "A").length;
      return `${ativos} ativo${ativos === 1 ? "" : "s"}`;
    },
    ultimaComunicacao() {
      const datas = this.listaLicencasOnline
        .map((i) => this.momentDoDatanet(i.created_at))
        .filter((d) => d && d.isValid());

      if (!datas.length) return null;

      return moment.max(datas).format("DD/MM/YYYY HH:mm");
    }
  },
  methods: {
    alternarTipo(chave) {
      this.filtroTipo = this.filtroTipo === chave ? null : chave;
      this.paginacaoSistemas.paginaAtual = 1;
    },

    limparFiltrosSistemas() {
      this.filtroTipo = null;
      this.buscaSistema = "";
      this.paginacaoSistemas.paginaAtual = 1;
    },

    // Sistema com sli_agente_virtual não depende de conector físico: as
    // consultas vão direto pelo DataNet. Marcar como "Offline" nesses casos
    // é falso alarme — por isso o estado próprio, na cor da marca.
    statusDoConector(sistema, conector) {
      if (sistema.sli_agente_virtual) {
        return {
          texto: "Virtual",
          icone: "fa-cloud",
          classe: "pnc-status--virtual"
        };
      }

      const online =
        conector &&
        this.listaLicencasOnline.some((i) => i.lic_token == conector.lic_token);

      return online
        ? { texto: "Online", icone: "fa-link", classe: "pnc-status--online" }
        : {
            texto: "Offline",
            icone: "fa-link-slash",
            classe: "pnc-status--offline"
          };
    },

    // O DataNet devolve created_at como string de locale americano
    // ("7/26/2026, 11:05:48 AM"), que não é RFC2822 nem ISO — o moment
    // caía no Date() do navegador e cuspia deprecation warning. Aqui o
    // formato vai explícito, com ISO como alternativa.
    momentDoDatanet(valor) {
      if (!valor) return null;

      const data = moment(valor, "M/D/YYYY, h:mm:ss A", true);
      return data.isValid() ? data : moment(valor, moment.ISO_8601);
    },

    formatarUltimaComunicacao(licToken) {
      const online = this.listaLicencasOnline.find(
        (i) => i.lic_token == licToken
      );
      if (!online) return "sem registro";

      const data = this.momentDoDatanet(online.created_at);
      return data && data.isValid()
        ? data.format("DD/MM/YYYY HH:mm")
        : "sem registro";
    },

    detalhes(item) {
      this.itemSelecionado = item;
      this.$modal.show("modal-detalhes-licenciada");
    },
    exibirConfiguracoesExtras(sistema) {
      this.itemSelecionado = sistema;
      this.$modal.show("configuracoes-extra");
    },
    editarSistema(item) {
      this.itemSelecionado = item;
      this.$emit("editar-licenciada", item.sistema_licenciada_id);
    },
    apagarSistema(item) {
      this.itemSelecionado = item;
      Swal.fire({
        title: 'Você deseja remover o sistema "' + item.sli_titulo + '"?',
        text: "Não será possivel reverter essa ação! Você pode desativar o sistema sem precisar removê-lo.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, quero remover!",
        cancelButtonText: "Cancelar"
      }).then((result) => {
        if (!result.isConfirmed) return;

        ApiService.delete(
          API_LINKS.sistemaLicenciada + "/" + item.sistema_licenciada_id
        ).then(() => {
          Swal.fire(
            "Removido",
            "Seu sistema foi removido com sucesso!",
            "success"
          );
          this.pegarDados();
        });
      });
    },
    async testarConexao(item) {
      this.exibirToast({
        severity: "info",
        summary: "Testando a conexão com o sistema",
        detail:
          "Isso pode demorar uma pouco! Mas logo iremos informar o resultado.",
        life: 5000
      });

      // Sem try/catch, um 401/404 aqui só aparecia no console — a tela
      // ficava com o toast de "testando" e nunca dizia o que houve.
      let response;
      try {
        response = await ApiService.get(
          API_LINKS.sistemaLicenciadaTestarConexao,
          item.sistema_licenciada_id
        );
      } catch (erro) {
        this.exibirToast({
          severity: "error",
          summary: "Não foi possível testar a conexão",
          detail:
            erro?.response?.data?.message ||
            "Não foi possível solicitar o teste de conexão.",
          life: 8000
        });
        return;
      }

      let requisicao = response.data.requisicao;
      if (requisicao.sucesso) {
        ApiService.get(
          API_LINKS.sistemaLicenciadaRespostaTesteConexao,
          item.sistema_licenciada_id + "/" + requisicao.uid
        )
          .then((response) => {
            requisicao = response.data.requisicao;
            const payload = requisicao.requisicao.resultado;
            if (requisicao.requisicao.sucesso_requisicao) {
              this.exibirToast({
                severity: "success",
                summary: "Teste de conexão bem sucedido!",
                detail: `Verificamos suas credenciais e tudo está funcionando corretamente. Resultado: ${JSON.stringify(
                  payload
                )}`,
                life: 7000
              });
              this.pegarDados();
            } else {
              this.exibirToast({
                severity: "error",
                summary: "Erro no teste de conexão",
                detail: `Verificamos suas credenciais e não foi possível se conectar!. Resultado: ${JSON.stringify(
                  payload
                )}`,
                life: 7000
              });
            }
          })
          .catch(() => {
            this.exibirToast({
              severity: "error",
              summary: "Erro no teste de conexão",
              detail: "Não foi possível se conectar ao sistema.",
              life: 7000
            });
          });
      } else {
        this.exibirToast({
          severity: "error",
          summary: "Erro no teste de conexão",
          detail: "Não foi possível solicitar o teste de conexão.",
          life: 7000
        });
      }
    },

    editarConector(item) {
      this.$emit("editar-conector", item);
    },
    apagarConector(item) {
      Swal.fire({
        title: 'Você deseja remover o conector "' + item.lic_descricao + '"?',
        text: "Não será possivel reverter essa ação! Você pode desativar o conector sem precisar removê-lo.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, quero remover!",
        cancelButtonText: "Cancelar"
      }).then((result) => {
        if (!result.isConfirmed) return;

        ApiService.delete(API_LINKS.licenca + "/" + item.licenciada_id).then(
          () => {
            Swal.fire(
              "Removido",
              "Seu conector foi removido com sucesso!",
              "success"
            );
            this.pegarDados();
          }
        );
      });
    },
    async atualizarCredenciaisConector(item) {
      this.exibirToast({
        severity: "info",
        summary: "Atualizando credenciais",
        detail:
          "Estamos entrando em contato com o conector para atualizar suas credenciais!",
        life: 4000
      });
      try {
        await ApiService.get(
          API_LINKS.forcarAtualizarCredenciais,
          item.licenciada_id,
          false
        );
        this.exibirToast({
          severity: "success",
          summary: "Suas credenciais foram atualizadas!",
          detail:
            "Atualizamos as informações de conexão contidas no conector! Isso pode demorar um pouco para surtir efeito.",
          life: 7000
        });
      } catch (error) {
        this.exibirToast({
          severity: "error",
          summary: "Erro em atualizar suas credenciais",
          detail:
            "Aconteceu um erro durante a tentativa de conexão com o conector! Tente novamente mais tarde.",
          life: 7000
        });
      }
    },

    obterDataFormatada(data) {
      return data
        ? moment(data, "YYYY-MM-DD HH:mm:ss")
            .locale("pt-br")
            .format("DD/MM/YYYY HH:mm")
        : "—";
    },
    exibirToast(toast) {
      this.$toast.removeAllGroups();
      this.$toast.add(toast);
    },

    // mostrarCarregamento=false: usado pelo botão "Atualizar"  — troca os
    // dados no lugar, sem cobrir a tela inteira com o spinner de novo.
    pegarDados(mostrarCarregamento = true) {
      if (mostrarCarregamento) this.carregando = true;
      const query = this.contaId ? `?conta_id=${this.contaId}` : "";

      return Promise.all([
        ApiService.get(API_LINKS.banco, "", false),
        ApiService.get(API_LINKS.sistema, "", false),
        ApiService.get(API_LINKS.sistemaLicenciada, query, false),
        ApiService.get(API_LINKS.licenca, query, false),
        // query aqui também: sem o conta_id o backend compara os tokens
        // online contra as licenciadas da conta logada, e todo conector de
        // outra conta aparecia offline na Central.
        ApiService.get(API_LINKS.licencasOnlines, query, false)
      ]).then(
        ([
          respBancos,
          respSistemas,
          respSistemaLicenciada,
          respLicenca,
          respOnline
        ]) => {
          this.bancos = respBancos.data.bancos;
          this.sistemasCatalogo = respSistemas.data.sistemas;
          this.sistemas = respSistemaLicenciada.data.sistemas;
          this.sistemasOrfaos = respSistemaLicenciada.data.sistemasOrfaos || 0;
          this.licenciadas = respLicenca.data.licenciadas;
          // agentes já vêm como lista de objetos com lic_token/created_at
          // direto do DataNetProvider::pegarLicencasOnline. O .map(item =>
          // item[0]) copiado do arquivo antigo só gerava undefined aqui.
          this.listaLicencasOnline = respOnline.data.agentes || [];

          this.carregando = false;
        }
      );
    },

    // Reinício de conector / atualização de licença refletem quase na hora
    // no backend, mas só apareciam aqui fechando e reabrindo o modal.
    //
    // O ícone gira durante TODO o bloqueio (não só durante a requisição) e
    // há uma segunda busca no fim: o agente leva alguns segundos pra
    // reportar que voltou, então só a busca imediata costumava trazer o
    // mesmo estado de antes e o botão parecia não fazer nada.
    atualizarManual() {
      if (this.cooldownAtivo) return;

      const SEGUNDOS_BLOQUEIO = 10;

      this.atualizando = true;
      this.cooldownAtivo = true;
      this.segundosRestantes = SEGUNDOS_BLOQUEIO;

      this.pegarDados(false);

      this.intervaloCooldown = setInterval(() => {
        this.segundosRestantes -= 1;

        if (this.segundosRestantes > 0) return;

        clearInterval(this.intervaloCooldown);
        this.intervaloCooldown = null;

        // Busca final: é aqui que o estado novo do conector costuma
        // aparecer, depois dele ter tido tempo de reportar.
        this.pegarDados(false).finally(() => {
          this.atualizando = false;
          this.cooldownAtivo = false;
        });
      }, 1000);
    }
  },
  watch: {
    // Remover um conector (ou trocar de conta) pode encolher a lista e
    // deixar a página atual fora do intervalo, mostrando um slide vazio.
    totalPaginasConectores(total) {
      if (this.paginaConectores > total - 1) {
        this.paginaConectores = Math.max(0, total - 1);
      }
    }
  },
  mounted() {
    this.pegarDados();
  },
  beforeDestroy() {
    // Fechar o modal no meio do cooldown deixaria o interval rodando.
    if (this.intervaloCooldown) clearInterval(this.intervaloCooldown);
  }
};
</script>

<style lang="scss" scoped>
.pnc-aviso {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.85rem 1rem;
  margin-bottom: 1rem;
  border-radius: 10px;
  background: #fff8e6;
  border-left: 4px solid #ffa800;

  > i {
    color: #ffa800;
    font-size: 1rem !important;
    margin-top: 0.1rem;
  }

  strong {
    display: block;
    font-size: 0.85rem;
    font-weight: 600;
    color: #7a5b00;
  }

  span {
    font-size: 0.78rem;
    color: #9a7b2e;
  }
}

// Faixa unica com divisorias, em vez de quatro caixas soltas.
.pnc-resumo {
  display: flex;
  flex-wrap: wrap;
  border: 1px solid #ebedf3;
  border-radius: 12px;
  background: #fff;
  margin-bottom: 1.75rem;
  overflow: hidden;
}

.pnc-resumo__item {
  flex: 1 1 200px;
  display: flex;
  align-items: center;
  gap: 0.85rem;
  padding: 1.1rem 1.25rem;

  & + & {
    border-left: 1px solid #f3f6f9;
  }
}

.pnc-resumo__icone {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  flex: 0 0 44px;

  i {
    font-size: 1.15rem !important;
  }

  &--roxo {
    background: #f2eefa;
    i {
      color: #7239ea !important;
    }
  }
  &--verde {
    background: #e3f5f0;
    i {
      color: #00a884 !important;
    }
  }
  &--azul {
    background: #e1f0ff;
    i {
      color: #3699ff !important;
    }
  }
  &--ambar {
    background: #fff5ea;
    i {
      color: #ff9f28 !important;
    }
  }
}

.pnc-resumo__dados {
  min-width: 0;
}

.pnc-resumo__valor {
  display: block;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1.15;
  color: #2b2640;
  font-variant-numeric: tabular-nums;

  // Data é mais longa que um número — não pode competir em tamanho.
  &--texto {
    font-size: 1rem;
    line-height: 1.3;
  }
}

.pnc-resumo__rotulo {
  display: block;
  font-size: 0.8rem;
  font-weight: 600;
  color: #3f4254;
}

.pnc-resumo__sub {
  display: block;
  font-size: 0.72rem;
  color: #a1a5b7;

  &--alerta {
    color: #f64e60;
    font-weight: 600;
  }
}

// ---- Pilula de status, usada na tabela e nos cards de conector ----
.pnc-status {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.1rem 0.5rem;
  border-radius: 999px;
  font-size: 0.7rem;
  font-weight: 600;
  white-space: nowrap;

  i {
    font-size: 0.65rem !important;
  }

  &__ponto {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: currentColor;
  }

  &--online {
    background: #e3f5f0;
    color: #00a884;
  }

  &--offline {
    background: #f3f6f9;
    color: #7c7c8a;
  }

  &--alerta {
    background: #fde6e8;
    color: #f64e60;
  }

  // Virtual não é sucesso nem falha — é outra natureza. Cor da marca.
  &--virtual {
    background: #f2eefa;
    color: #7239ea;
  }
}

// ---- Coluna Sistema ----
.pnc-sistema {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  cursor: pointer;
  min-width: 0;
}

.pnc-sistema__icone {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 9px;
  flex: 0 0 34px;

  i {
    font-size: 0.9rem !important;
  }
}

.pnc-sistema__texto {
  min-width: 0;
}

.pnc-sistema__nome {
  display: block;
  font-size: 0.85rem;
  font-weight: 600;
  color: #2b2640;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pnc-sistema__sub {
  display: block;
  font-size: 0.72rem;
  color: #a1a5b7;
}

.pnc-endereco {
  font-size: 0.8rem;
  color: #5e6278;
  inline-size: 240px;
  overflow-wrap: break-word;
}

.pnc-conector-col {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  align-items: flex-start;
}

.pnc-conector-col__nome {
  font-size: 0.82rem;
  font-weight: 600;
  color: #2b2640;
}

.pnc-ultimo-teste {
  font-size: 0.8rem;
  color: #5e6278;
  font-variant-numeric: tabular-nums;

  &--nunca {
    color: #b5b5c3;
    font-style: italic;
  }
}

// Título + ação na mesma linha, mesmo arranjo dos cards do Dashboard.
.pnc-secao {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

// Mesma escala do .card-titulo global (1.1rem) usada no Dashboard.
.pnc-titulo {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: #2b2640;
}

.pnc-titulo__contador {
  background: #f3f6f9;
  color: #7c7c8a;
  border-radius: 999px;
  padding: 0.05rem 0.55rem;
  font-size: 0.75rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.pnc-secao__acoes {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.pnc-ordem {
  display: inline-flex;
  border: 1.5px solid #e4e6ef;
  border-radius: 8px;
  overflow: hidden;
}

.pnc-ordem__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 26px;
  padding: 0;
  border: 0;
  background: #fff;
  color: #b5b5c3;
  cursor: pointer;
  transition: all 0.15s ease;

  & + & {
    border-left: 1px solid #e4e6ef;
  }

  i {
    font-size: 0.72rem !important;
  }

  &:hover {
    color: #472282;
  }

  &--ativo {
    background: #f2eefa;
    color: #7239ea;
  }
}

.pnc-slide-nav {
  display: flex;
  align-items: center;
  gap: 0.4rem;
}

.pnc-slide-pos {
  font-size: 0.75rem;
  font-weight: 600;
  color: #7c7c8a;
  font-variant-numeric: tabular-nums;
}

.pnc-slide-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 1.5px solid #e4e6ef;
  border-radius: 8px;
  background: #fff;
  color: #7c7c8a;
  cursor: pointer;
  transition: all 0.15s ease;

  i {
    font-size: 0.75rem !important;
  }

  &:hover:not(:disabled) {
    color: #472282;
    border-color: #472282;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.45;
  }
}

.pnc-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.1rem 0.45rem;
  border-radius: 5px;
  font-size: 0.68rem;
  font-weight: 600;
  white-space: nowrap;
}

.pnc-sistema__badges {
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  margin-top: 0.2rem;
}

// Mesmo desenho dos chips de filtro da Timeline.
.pnc-filtros {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.4rem;
}

.pnc-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  height: 28px;
  padding: 0 0.6rem;
  border-radius: 8px;
  border: 1.5px solid #e4e6ef;
  background: #fff;
  color: #7c7c8a;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;

  i {
    font-size: 0.78rem !important;
  }

  &:hover {
    border-color: #d7d2e8;
  }

  &--limpar {
    color: #b5b5c3;
  }
}

.pnc-chip__contador {
  padding: 0 0.3rem;
  border-radius: 999px;
  background: #f3f6f9;
  color: #7c7c8a;
  font-size: 0.68rem;
  font-variant-numeric: tabular-nums;
}

.pnc-busca {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  height: 28px;
  padding: 0 0.6rem;
  border-radius: 8px;
  border: 1.5px solid #e4e6ef;
  background: #fff;

  > i {
    color: #b5b5c3;
    font-size: 0.72rem !important;
  }

  input {
    border: 0;
    outline: 0;
    background: transparent;
    font-size: 0.75rem;
    color: #2b2640;
    width: 140px;

    &::placeholder {
      color: #b5b5c3;
    }
  }

  button {
    border: 0;
    background: transparent;
    padding: 0;
    color: #b5b5c3;
    cursor: pointer;

    &:hover {
      color: #472282;
    }

    i {
      font-size: 0.72rem !important;
    }
  }
}

.pnc-vazio {
  padding: 1.5rem;
  text-align: center;
  color: #b5b5c3;
}

.pnc-conectores {
  display: flex;
  flex-wrap: wrap;
  gap: 0.85rem;
}

.pnc-conector {
  flex: 1 1 280px;
  min-width: 0;
  border: 1px solid #ebedf3;
  border-radius: 12px;
  background: #fff;
  overflow: hidden;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    border-color: #d7d2e8;
    box-shadow: rgba(100, 100, 111, 0.1) 0px 4px 14px 0px;
  }
}

.pnc-conector__cabecalho {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 1rem;
}

.pnc-conector__icone {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 11px;
  flex: 0 0 42px;
  background: #f2eefa;

  i {
    color: #7239ea !important;
    font-size: 1.05rem !important;
  }

  // Offline perde a cor: o card inteiro comunica o estado, não só a pílula.
  &--off {
    background: #f3f6f9;

    i {
      color: #b5b5c3 !important;
    }
  }
}

.pnc-conector__identificacao {
  flex: 1 1 auto;
  min-width: 0;
}

.pnc-conector__titulo {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 0;
}

.pnc-conector__nome {
  font-size: 0.9rem;
  font-weight: 600;
  color: #2b2640;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pnc-conector__versao {
  margin-top: 0.15rem;
  font-size: 0.78rem;
  color: #5e6278;
}

.pnc-conector__linha {
  margin-top: 0.3rem;
  font-size: 0.72rem;
  color: #a1a5b7;

  i {
    font-size: 0.7rem !important;
  }
}

.pnc-conector__menu {
  color: #b5b5c3;

  &:hover {
    color: #472282;
  }
}

// Rodapé separado por linha, como na referência.
.pnc-conector__rodape {
  padding: 0.65rem 1rem;
  border-top: 1px solid #f3f6f9;
  background: #fcfcfd;
  font-size: 0.75rem;
  font-weight: 600;
  color: #7c7c8a;

  i {
    color: #b5b5c3;
  }
}

// A tabela vinha com a tipografia default do b-table, destoando dos cards.
::v-deep #tabelaSistemasConectados {
  margin-bottom: 0.5rem;

  th {
    font-size: 0.7rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: #a1a5b7;
    border-top: 0;
    border-bottom: 1px solid #ebedf3;
    padding: 0.6rem 0.75rem;
    white-space: nowrap;
  }

  td {
    font-size: 0.85rem;
    color: #2b2640;
    vertical-align: middle;
    border-top: 0;
    border-bottom: 1px solid #f3f6f9;
    padding: 0.7rem 0.75rem;
  }

  tbody tr:last-child td {
    border-bottom: 0;
  }

  tbody tr:hover {
    background: #fcfcfd;
  }
}
</style>
